import React, { useState, useContext, useEffect } from "react";
import "./AddNewLineage.css";
// import AzureDataLakeImg from "../../assets/images/DatabaseIcons/AzureDataLake.webp";
// import ClickHouseImg from "../../assets/images/DatabaseIcons/Clickhouse.svg";
// import DreamioImg from "../../assets/images/DatabaseIcons/dreamio.svg";
// import MicrosoftSQLImg from "../../assets/images/DatabaseIcons/MicrosoftSQL.svg";
// import MySQLImg from "../../assets/images/DatabaseIcons/mysql.svg";
// import OracleImg from "../../assets/images/DatabaseIcons/Oracle.svg";
// import PostgreImg from "../../assets/images/DatabaseIcons/postgre.svg";
// import RedshiftImg from "../../assets/images/DatabaseIcons/Redshift.svg";
// import SalesForceImg from "../../assets/images/DatabaseIcons/Salesforce.png";
// import SnowflakeImg from "../../assets/images/DatabaseIcons/snowflake.svg";
// import SFTCImg from "../../assets/images/DatabaseIcons/SFTC.png";
import DataBricks from "./LineageForm/DataBricks";
// import Snowflake from "./LineageForm/Snowflake";
import DataBricksLogo from "../../assets/images/LineageIcons/Databricks_dark_logo.png";
import { useNavigate } from "react-router-dom";
// import { useLocation } from "react-router-dom";
// import { Container, Breadcrumb, Row, Col, Card } from "react-bootstrap";
import axios from "axios";
import { AuthContext } from "../../AuthContext";
import { useMsal } from "@azure/msal-react";
import { protectedResources } from "../../msalConfig";
import { MARTBUILDER_API } from "../../constants/serverConfig";
// import AzureDataLake from "./LineageForm/AzureDataLake";
import APIEndpoint from "./LineageForm/APIEndpoint";
// import Dremio from "./LineageForm/Dremio";
// import Redshift from "./LineageForm/Redshift";
import SalesForce from "./LineageForm/SalesForce";
import CommonBreadcrumb from "../CommonBreadcrumb/CommonBreadcrumb";
import { BsPatchCheckFill } from "react-icons/bs";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

// const imagesData = [
//   { name: "Postgre", image: PostgreImg },
//   { name: "AzureDataLake", image: AzureDataLakeImg },
//   { name: "Dreamio", image: DreamioImg },
//   { name: "MicrosoftSQL", image: MicrosoftSQLImg },
//   { name: "MySQL", image: MySQLImg },
//   { name: "Oracle", image: OracleImg },
//   { name: "SalesForce", image: SalesForceImg },
//   { name: "Snowflake", image: SnowflakeImg },
// ];

const AddNewLineage = () => {
  const { dcerror, dctoken, getDatacraftToken, prtoken, getProductRegistrationToken } = useContext(AuthContext);
  const { instance } = useMsal();
  const account = instance.getActiveAccount();
  const request = {
    scopes: protectedResources.datacraft.scopes,
    account: account,
  };
  const navigate = useNavigate();

  const [selectedLineage, setSelectedLineage] = useState("DataBricks");
  const [productTableData, setProductTableData] = useState([]);
  // to show hide submit btn on success of test connection
  const [testConnectionSuccess, setTestConnectionSuccess] = useState(false);
  //to show hide checkmetadata now btn on success of submit
  const [submissionSuccess, setSubmissionSuccess] = useState(false);

  const [newConnectionData, setNewConnectionData] = useState({
    connectionId: "",
    connectionFqn: "",
    connectionName: "",
    datasourceType: selectedLineage,
    product: { id: "" },
    // description: "", yet to be added in api schema
    vaultKey: "",
  });

  const [startDate, setStartDate] = useState(dayjs("2022-04-17T15:30"));
  const [endDate, setEndDate] = useState(dayjs("2022-04-20T15:30"));

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "product") {
      setNewConnectionData((prevState) => ({
        ...prevState,
        product: { id: value },
      }));
    } else if (
      ["hostName", "portName", "userName", "password", "database"].includes(
        name
      )
    ) {
      setNewConnectionData((prevState) => ({
        ...prevState,
        connectionCreds: {
          ...prevState.connectionCreds,
          [name]: value,
        },
      }));
    } else {
      setNewConnectionData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  useEffect(() => {
    callapiwithtoken(fetchProductTableData);
  }, [dctoken, dcerror]);

  // const handleSubmit = async (isTestConnection = false) => {
  const handleSubmit = async (formdataPayload, isTestConnection) => {
    if (!validateForm()) {
      return;
    }
    callapiwithtoken((dctoken) =>
      handlePostAPI(dctoken, formdataPayload, isTestConnection)
    );
  };

  const validateForm = () => {
    const { connectionName, product, description } = newConnectionData;
    if (!connectionName || !product.id || !description) {
      alert(
        "Please fill all required fields: Connection Name, Product, and Description."
      );
      return false;
    }
    return true;
  };

  const navigateMetaDataCrawl = () => {
    navigate("/databook/metadataCrawl");
  };

  const handleDatabaseSelect = (lineageName) => {
    setSelectedLineage(lineageName);
    setNewConnectionData((prevState) => ({
      ...prevState,
      datasourceType: lineageName,
    }));
    setTestConnectionSuccess(false);
    setSubmissionSuccess(false);
  };

  const fetchProductTableData = async (dctoken) => {
    console.log(dctoken, "<==dctoken");
    const ourRequest = axios.CancelToken.source();
    try {
      let response = await axios.get(`${MARTBUILDER_API}/product`, {
        headers: {
          Authorization: `Bearer ${dctoken}`,
          "Content-Type": "application/json",
        },
        CancelToken: ourRequest.token,
      });
      setProductTableData(response?.data);
      console.log(response, "<==response");
    } catch (err) {
      if (axios.isCancel(err)) {
        return;
      } else {
        console.error(err);
      }
    }
    return () => {
      ourRequest.cancel();
    };
  };

  useEffect(() => {
    getProductRegistrationToken();
  }, [prtoken])

  const callapiwithtoken = async (callback) => {
    (async () => await getDatacraftToken())();
    if (dctoken) {
      await callback(dctoken);
    }
    if (dcerror) {
      try {
        const rtoken = (await instance.acquireTokenRedirect(request))
          .accessToken;
        await callback(rtoken);
      } catch (error) {
        console.log(error);
      }
    }
  };

  //below we have created a function for handling custom payload
  const handlePostAPI = (dctoken, formdataPayload, isTestConnection) => {
    // console.log(formdataPayload, "<===formdataPayload before");
    // console.log(isTestConnection, "<===isTestConnection before");
    const payload = {
      ...newConnectionData,
      connectionCreds: JSON.stringify(formdataPayload.connectionCreds),
    };
    // console.log(payload, "<===formdataPayload after");
    // console.log(isTestConnection, "<===isTestConnection after");
    const ourRequest = axios.CancelToken.source();
    const sendJobData = async () => {
      try {
        // console.log(customPayload, "<== inside call");
        let endpoint = isTestConnection
          ? "/metadatacrawl/test/"
          : "/datasources";
        console.log(endpoint, "ENDPOINT");
        console.log(payload, "payload");
        let response = await axios.post(
          `${MARTBUILDER_API}${endpoint}`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${dctoken}`,
              "Content-Type": "application/json",
            },
          }
        );
        //console.log(response.status, "RESPONSE");
        if (response.status === 200 && isTestConnection) {
          setTestConnectionSuccess(true);
          alert(`Test connection successful.`);
        } else if (
          (response.status === 200 || response.status === 201) &&
          !isTestConnection
        ) {
          setSubmissionSuccess(true);
          setTestConnectionSuccess(false);
          alert(`Data submitted successfully.`);
        }
        //  else if (response.status === 200) {
        //   alert(`Data submitted successfully.`);
        // }
        //  else if (response.status === 201) {
        //   alert(`Data submitted successfully.`);
        // }
        else {
          alert(`Success with status ${response.status}: ${response.data}`);
        }
      } catch (err) {
        if (axios.isCancel(err)) {
          console.log("Request canceled", err.message);
        } else if (err.response) {
          alert(`Error ${err.response.status}: ${err.response.data}`);
        } else if (err.request) {
          console.log(err.request);
          alert("The request was made but no response was received");
        } else {
          console.log("Error", err.message);
          alert("Error: " + err.message);
        }
      } finally {
        if (!isTestConnection) {
          // navigate("/manageDatasources");
        }
      }
    };
    sendJobData();
  };

  return (
    <div className="">
      <CommonBreadcrumb
        href1={"/databook/addNewLineage"}
        path1={"Add New Lineage"}
      />
      <h3 className="pageHeading">Add New Lineage</h3>
      <div className="mainLSwrapper">
        {/* <div className="individualLRow">
          <div>
            <label htmlFor="connectionName">Connection Name</label>
            <br />
            <input
              type="text"
              id="connectionName"
              name="connectionName"
              placeholder="Enter Connection Name"
              onChange={handleChange}
            />
          </div>
          <div>
            <label htmlFor="product">Products</label>
            <br />
            <select
              id="product"
              name="product"
              onChange={handleChange}
              value={newConnectionData.product.id}
            >
              {productTableData.map((product, index) => (
                <option key={index} value={product.id}>
                  {product.name}
                </option>
              ))}
            </select>
          </div>
        </div> */}
        {/* <div className="individualLRow">
          <div className="inputWrapper">
            <label htmlFor="description">Description</label>
            <br />
            <textarea
              id="description"
              name="description"
              rows="4"
              cols="50"
              placeholder="Enter Description"
              onChange={handleChange}
            ></textarea>
          </div>
        </div> */}
        <div
          className="individualLRow"
          style={{ borderBottom: "1px solid #d3d3d3", padding: "30px" }}
        >
          <div>
            <label htmlFor="resourceType" id="sub-heading" className="ANLLabel">
              Resource Type
            </label>
            <br />
            <br />
            <div className="imageWrapper">
              {/* {imagesData.map((data, index) => (
                <>
                  <div
                    className={`lineageIconsImage ${
                      selectedLineage === data.name ? "selectedImage" : ""
                    }`}
                    key={index}
                    onClick={() => handleDatabaseSelect(data.name)}
                  >
                    <img src={data.image} alt={data.name} />
                    <p>{data.name}</p>
                  </div>
                </>
              ))} */}
              <>
                <div
                  className={`lineageIconsImage ${selectedLineage === "DataBricks" ? "selectedImage" : ""
                    }`}
                  style={
                    selectedLineage === "DataBricks"
                      ? {}
                      : {
                        border: "1px solid rgb(234, 234, 234)",
                        backgroundColor: "white",
                      }
                  }
                  onClick={() => handleDatabaseSelect("DataBricks")}
                >
                  <img src={DataBricksLogo} alt="DataBricksLogo" />
                  <p style={{ fontWeight: "800", color: "#000000" }}>
                    Data Bricks
                  </p>
                </div>
              </>
              <>
                <div
                  className={`lineageIconsImage ${selectedLineage === "APIEndpoint" ? "selectedImage" : ""
                    }`}
                  style={
                    selectedLineage === "APIEndpoint"
                      ? {}
                      : {
                        border: "1px solid rgb(234, 234, 234)",
                        backgroundColor: "white",
                      }
                  }
                  onClick={() => handleDatabaseSelect("APIEndpoint")}
                >
                  <h4 style={{ textAlign: "center", fontWeight: "600" }}>
                    API Endpoint
                  </h4>
                </div>
              </>
            </div>
          </div>
        </div>
        {selectedLineage === "DataBricks" && (
          <DataBricks
            connectionData={newConnectionData}
            handleChange={handleChange}
            onSubmitFun={handleSubmit}
            testConnectionSuccess={testConnectionSuccess}
            setTestConnectionSuccess={setTestConnectionSuccess}
            submissionSuccess={submissionSuccess}
          />
        )}
        {selectedLineage === "APIEndpoint" && (
          <APIEndpoint
            connectionData={newConnectionData}
            handleChange={handleChange}
            onSubmitFun={handleSubmit}
            testConnectionSuccess={testConnectionSuccess}
            submissionSuccess={submissionSuccess}
          />
        )}
        {selectedLineage === "SalesForce" && (
          <SalesForce
            connectionData={newConnectionData}
            handleChange={handleChange}
            onSubmitFun={handleSubmit}
            testConnectionSuccess={testConnectionSuccess}
            submissionSuccess={submissionSuccess}
          />
        )}
        {/* {testConnectionSuccess && ( */}
        <>
          <div
            className="individualLRow"
            style={{ justifyContent: "flex-start", gap: "8px" }}
          >
            <BsPatchCheckFill size={20} fill="#007fff" />{" "}
            <p id="successPara">
              Success! Connection to the ADB resource is established.
            </p>
          </div>
          <div
            className="individualLRow"
            style={{ borderTop: "1px solid #d3d3d3" }}
          >
            <div>
              <label
                htmlFor="EnableLineage"
                id="sub-heading"
                className="ANLLabel"
              >
                Enable Lineage Pipeline Process
              </label>
            </div>
          </div>
          <div className="individualLRow" style={{ padding: "10px 30px" }}>
            <div>
              <label
                htmlFor="Startineage"
                id="sub-heading"
                className="ANLLabel"
              >
                Lineage Start Date
              </label>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateTimePicker
                  // label="Lineage Start Date"
                  value={startDate}
                  onChange={(newValue) => setStartDate(newValue)}
                />
              </LocalizationProvider>
            </div>
            <div>
              <label htmlFor="EndLineage" id="sub-heading" className="ANLLabel">
                Lineage End Date
              </label>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateTimePicker
                  // label="Lineage End Date"
                  value={endDate}
                  onChange={(newValue) => setEndDate(newValue)}
                />
              </LocalizationProvider>
              <p id="successPara">
                * End date is automatically set for 3 days from start date.
              </p>
            </div>
          </div>
        </>
        {/* )} */}
      </div>
      {selectedLineage === "DataBricks" && (
        <div className="btnWrapper">
          <button
            className="job-btn btn nar-wid"
            style={{ marginLeft: "11px" }}
            onClick={navigateMetaDataCrawl}
          // disabled={!submissionSuccess}
          >
            Submit
          </button>
        </div>
      )}
      {selectedLineage === "APIEndpoint" && (
        <div className="btnWrapper">
          <button
            className="job-btn btn nar-wid"
            style={{ marginLeft: "11px" }}
            onClick={navigateMetaDataCrawl}
          // disabled={!submissionSuccess}
          >
            Process Lineage
          </button>
        </div>
      )}
    </div>
  );
};

export default AddNewLineage;
